import { defineComponent as _defineComponent } from 'vue'
import { getAdvList } from '@/api/operation/advertising';
import { useForm } from '@/util/useForm';
import { computed, reactive, ref, watch } from 'vue';
import NDrawer from '@/component/NDrawer/NDrawer.vue';
import AdvDetail from './AdvDetail.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OperationAdvertising',
  setup(__props) {

const dataSource = ref<any>([]);
const queryParams = ref<{
  [key: string]: any;
  current?: number;
  limit?: number;
}>({ current: 1 });
watch(
  queryParams,
  (newVal, oldVal) => {
    query();
  },
  { immediate: true }
);
async function query(params = queryParams.value) {
  const res = await getAdvList(params);
  dataSource.value = [{ id: 1 }, { id: 2 }, { id: 3 }] || res.detail;
  pagination.value = {
    ...pagination.value,
    current: res.current,
    total: res.total,
    pageSize: res.limit,
  };
}
const form = useForm();
function submit(e) {
  e.preventDefault();
  form.value.validateFields((err, values) => {
    if (!err) {
      queryParams.value = { ...queryParams.value, ...values };
    }
  });
}
function clearForm() {
  form.value.resetFields();
  form.value.validateFields((err, values) => {
    if (!err) {
      queryParams.value = { ...queryParams.value, ...values };
    }
  });
}
const pagination = ref({
  current: 1,
  total: 0,
  pageSize: 20,
  showTotal: () =>
    computed(() => `共${pagination.value.total}条, 每页${pagination.value.pageSize}条`),
});
function onPagination({ current, pageSize }) {
  pagination.value = {
    ...pagination.value,
    current,
    pageSize,
  };
  queryParams.value = {
    ...queryParams.value,
    current,
    limit: pageSize,
  };
}
const visible = ref(false);

return { __sfc: true,dataSource, queryParams, query, form, submit, clearForm, pagination, onPagination, visible, NDrawer, AdvDetail }
}

})